import GPanelContactsLabelsLogs from './gpanel-contacts-labels-logs';

export default function GPanelContactsLabelsLogsPage() {
  return <GPanelContactsLabelsLogs />;
}
